<mat-card class="twikit-parameter-card">
  <mat-card-title class="twikit-parameter-title">{{title}}</mat-card-title>
  <mat-card-content>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
